<template lang="pug">
  header.header(:class="[transparent, fixed, hidden]")
    .container.header__container
      .header__row
        .header__left
          router-link.logo-link.header__logo-link(to="/")
            svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 60 45.25').logo
              path.a(d='M.521,4.558H0L1.665,0H1.9L3.575,4.556H3.023L2.572,3.314H.959L.521,4.558ZM1.766.807h0L1.609,1.5,1.128,2.852H2.417L1.929,1.487,1.772.807Z', transform='translate(28.174 40.365)')
              path.a(d='M.521,4.54H0V.1C.161.066.341.043.55.025S.953,0,1.119,0a2.327,2.327,0,0,1,.55.064,1.286,1.286,0,0,1,.459.211,1.082,1.082,0,0,1,.317.385,1.274,1.274,0,0,1,.12.577,1.263,1.263,0,0,1-.283.852,1.367,1.367,0,0,1-.716.436l.3.238L2.959,4.537l-.608,0L1.138,2.6l-.617-.1V4.539ZM.961.462C.9.462.844.464.792.468l-.054,0-.1.008A.612.612,0,0,0,.521.5V2.154h.49a1.145,1.145,0,0,0,.717-.218.807.807,0,0,0,.283-.679A.762.762,0,0,0,1.778.686.9.9,0,0,0,1.131.462Z', transform='translate(36.733 40.384)')
              path.a(d='M3,4.378a1.119,1.119,0,0,1-.478.205,3.154,3.154,0,0,1-.616.058A1.985,1.985,0,0,1,1.162,4.5a1.625,1.625,0,0,1-.6-.42A2.035,2.035,0,0,1,.15,3.362,3.214,3.214,0,0,1,0,2.321,3.021,3.021,0,0,1,.166,1.253,2.049,2.049,0,0,1,.606.535,1.687,1.687,0,0,1,1.219.128,1.942,1.942,0,0,1,1.911,0a3.708,3.708,0,0,1,.615.042,1.961,1.961,0,0,1,.409.112L2.809.628A1.941,1.941,0,0,0,1.948.474a1.417,1.417,0,0,0-.509.1A1.178,1.178,0,0,0,.99.885a1.582,1.582,0,0,0-.316.57,2.685,2.685,0,0,0-.12.865,2.6,2.6,0,0,0,.113.808,1.67,1.67,0,0,0,.311.577,1.278,1.278,0,0,0,.465.346,1.451,1.451,0,0,0,.581.116,1.891,1.891,0,0,0,.493-.058,1.367,1.367,0,0,0,.355-.148Z', transform='translate(20.663 40.359)')
              path.b(d='M38.84,35.372H37.492V24.524H38.84v5.349l5.243-5.349H45.99L41,29.614l5.642,5.755-1.905,0-4.691-4.785L38.84,31.817v3.554Zm11.784,0H49.151l4.688-10.84,0-.007h1.481l0,.007L60,35.369l-1.472,0L57.074,32.01H53.5a1.246,1.246,0,0,1,1.394-1.375h1.589l-1.9-4.4-3.951,9.137Zm-16.612,0H26.5V24.524h1.347V34h6.169V35.37Zm-12.271,0H13.927V24.524h7.815V25.9H15.275V29.26H20.7v1.375h-5.43V34h6.466V35.37Zm-14.686,0H1.4V25.9h-.05a1.4,1.4,0,0,1-1-.371A1.362,1.362,0,0,1,0,24.524H6.217l.073,0a2.949,2.949,0,0,1,2.068.917,3.092,3.092,0,0,1,.09,4.167,3.066,3.066,0,0,1-1.393,5.759ZM2.751,25.9V34h4.3A1.666,1.666,0,0,0,8.7,32.315c0-1.786-2.169-2.454-2.191-2.461A3.187,3.187,0,0,0,7.864,27.58,1.666,1.666,0,0,0,6.217,25.9ZM32.3,18.382H28a1.657,1.657,0,0,1-1.638-1.671l5.945,0A3.514,3.514,0,0,0,33.9,10.1l-1.859-1,1.4-1.6a3.537,3.537,0,0,0-.1-4.773,3.389,3.389,0,0,0-2.371-1.052l-.235-.006H24.671A1.656,1.656,0,0,1,23.033,0L27,0h4V.006a5.008,5.008,0,0,1,3.506,1.555,5.239,5.239,0,0,1,.153,7.061A5.186,5.186,0,0,1,37.381,13.2,5.134,5.134,0,0,1,32.3,18.382ZM26.359,15.04H24.671a1.657,1.657,0,0,1-1.638-1.671h3.326v1.67Zm0-3.343H23.032a1.656,1.656,0,0,1-1.638-1.67h4.965V11.7Zm0-3.342H21.394a1.657,1.657,0,0,1-1.638-1.671h6.6v1.67Zm0-3.343h-6.6a1.656,1.656,0,0,1-1.638-1.67h8.242V5.012Z')

          nav.nav-row.header__nav-row
            router-link.nav-row__link(v-for="item in menu" :key="item.link" :to="item.link") {{item.name}}
        .header__right
          a.tel.header__tel(href="tel:+74952343300") #[i.icon-tel.tel__icon] +7&nbsp;495&nbsp;234 33&nbsp;00
          router-link.header__login-link(to="/login") Войти
          a.menu-icon(href="#" @click.prevent="toggleMenu")
            .menu-icon__box
              .menu-icon__item
              .menu-icon__item
              .menu-icon__item
          a.language.header__language(href="#") RU #[i.icon-arrow-down.language__icon]

    .menu
      .menu__inner
        .menu__nav
          nav-grid

</template>

<script>
import navGrid from './nav-grid.vue'

export default {
  name: 'Header',
  components: {
    navGrid
  },
  data () {
    return {
      didScroll: false,
      lastScrollTop: 0,
      header: {
        fixed: false,
        hidden: false
      },
      menu: [
        {
          name: 'Аэропорты',
          link: '/airports'
        },
        {
          name: 'Тарифы',
          link: '/rates'
        },
        {
          name: 'Правила',
          link: '/rules'
        },
        {
          name: 'FAQ',
          link: '/faq'
        },
        {
          name: 'Медиацентр',
          link: '/mediacenter'
        },
        {
          name: 'Контакты',
          link: '/contacts'
        }
      ]
    }
  },
  methods: {
    toggleMenu () {
      const el = document.body
      if (!this.menuOpened) {
        el.classList.add('body-fixed', 'menu-opened')
      } else {
        el.classList.remove('body-fixed', 'menu-opened')
      }
      this.menuOpened = !this.menuOpened
    },
    handleScroll (event) {
      this.didScroll = true
      setInterval(() => {
        if (this.didScroll) {
          this.hasScrolled()
          this.didScroll = false
        }
      }, 250)
    },
    hasScrolled () {
      let offsetTop = pageYOffset
      let delta = 0

      if (Math.abs(this.lastScrollTop - offsetTop) <= delta) return

      if (offsetTop > this.lastScrollTop) {
        // scroll down
        this.header.fixed = false
        this.header.hidden = true
      } else if (offsetTop <= 0) {
        this.header.fixed = false
        this.header.hidden = false
      } else {
        if (offsetTop + window.innerHeight < document.body.scrollHeight) {
          // scroll top
          this.header.fixed = true
          this.header.hidden = false
        }
      }
      this.lastScrollTop = offsetTop
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    transparent () {
      return this.$route.meta.transparentHeader ? 'header_transparent' : ''
    },
    fixed () {
      return this.header.fixed ? 'header_fixed' : ''
    },
    hidden () {
      return this.header.hidden ? 'header_hidden' : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue